<template>
<!-- main -->
<main id="container">

    <!-- 문의 완료 -->
    <section id="complete" class="section">
        <div class="inner">
            <div class="contents_area">
                <div class="top">
                    <img :src="imgPath+'complete_img.png'" alt="">
                    <p>
                        <u>T_앨리 문의 완료</u>
                        <span>
                            법인컨설팅의 명가. 피플라이프의 또 하나의 브랜드<br>
                            전문가를 위한 통합 컨설팅 전문가 그룹 <b>CEO클리닉 Tax Alliance</b>에서<br>
                            새로운 기회를 잡으세요. 
                        </span>
                    </p>
                </div>
                <button type="button">이전으로</button>
            </div>
        </div>
    </section>
    <!-- //문의 완료 -->
    
</main>
<!-- /main -->
</template>


<script>
export default {
    data() {
        return {
            imgPath: '/img/recruit/tallyComplete/'
        }
    }
}
</script>


<style scoped lang="scss">
    @import '@/assets/scss/recruit/tallyComplete.scss';
</style>